/**
 * Pure theme resolution — the single source of truth for "which theme wins".
 * Kept DOM-free so it is unit-testable without a browser. The provider stamps
 * the result as `data-theme` on the root; the SCSS token maps re-bind.
 */

/** What the user chose. `auto` defers to the OS `prefers-color-scheme`. */
export type ThemeOverride = 'light' | 'dark' | 'auto';

/** A concrete theme the tokens resolve against. */
export type ResolvedTheme = 'light' | 'dark';

/**
 * Resolve the effective theme. An explicit `override` (`light`/`dark`) ALWAYS
 * wins — in both directions — over the OS preference; `auto` follows
 * `prefersDark`.
 */
export function resolveTheme(override: ThemeOverride, prefersDark: boolean): ResolvedTheme {
  if (override === 'light') return 'light';
  if (override === 'dark') return 'dark';
  return prefersDark ? 'dark' : 'light';
}
